<div class="ne-progress-container">
  <div style="background-image: url({$theme.logoSrc.state})" class="ne-logo"></div>
  <progress class="ne-progress" max='100' value={progress} />
  <div class="ne-progress-text">Uploading photo...</div>
</div>

<style>
  .ne-progress-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
  }

  .ne-logo {
    width: 2em;
    height: 2em;
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
  }

  .ne-progress {
    display: inline-block;
    -webkit-appearance: none;
    height: .25em;
    width: 8em;
    margin: 1em 0 .5em;
  }

  .ne-progress::-moz-progress-bar {
    background: #CE2333;
  }

  .ne-progress::-webkit-progress-value {
    background: #CE2333;
    -webkit-appearance: none;
  }

  .ne-progress::-webkit-progress-bar {
    background: #cecece;
    -webkit-appearance: none;
  }

</style>

<script>
  import { theme } from '../stores';

  export let progress = 0;
</script>
